import { Accordion, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";


import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import ExpenseViewModal from "./ExpenseViewModal";
import { useSearchParams } from "react-router-dom";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import * as XLSX from "xlsx-js-style";
import { organisationSignal } from "../../../signal/organisationSignal";

export default function ExpenseList() {

    let today = Date.now();
    // get date start Time of 7 days ago in milliseconds
    let sevenDaysAgo = new Date(today - 7 * 24 * 60 * 60 * 1000).getTime();

    const [searchParams, setSearchParams] = useSearchParams();
    const [expenses, setExpenses] = useState([]);
    const [expenseToDisplay, setExpenseToDisplay] = useState([]);
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(sevenDaysAgo).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(today).format("YYYY-MM-DD"));
    const [search, setSearch] = useState("");
    const [text, setText] = useState({})
    const [showExpenseViewModal, setShowExpenseViewModal] = useState(false);
    const [selectedExpense, setSelectedExpense] = useState(null);
    const [maxAmount, setMaxAmount] = useState(searchParams.get("maxAmount") ? parseFloat(searchParams.get("maxAmount")) : 0);
    const [minAmount, setMinAmount] = useState(searchParams.get("minAmount") ? parseFloat(searchParams.get("minAmount")) : 0);
    const [statusFilter, setStatusFilter] = useState(searchParams.get("statusFilter") ? searchParams.get("statusFilter") : "");
    const [isExporting, setIsExporting] = useState(false);

    const getRatePerKm = (userId, modeOfTransport) => {
        if (!modeOfTransport) return 0;
        const cleanMode = modeOfTransport.toLowerCase().trim();
        
        // 1. Check user-specific override
        const userObj = allUsersSignal?.value?.[userId];
        if (userObj && userObj.modeOfTransports && userObj.modeOfTransports.length > 0) {
            const found = userObj.modeOfTransports.find(m => m.name && m.name.toLowerCase().trim() === cleanMode);
            if (found && found.amount !== undefined && found.amount !== null && found.amount !== -1) {
                return parseFloat(found.amount);
            }
        }
        
        // 2. Check organisation default
        const orgTransports = organisationSignal?.value?.modeOfTransports || [];
        const found = orgTransports.find(m => m.name && m.name.toLowerCase().trim() === cleanMode);
        if (found && found.amount !== undefined && found.amount !== null && found.amount !== -1) {
            return parseFloat(found.amount);
        }
        
        return 0;
    };

    const buildRouteFromTasks = (trip) => {
        let str = "";
        const tasks = trip?.tasks || [];
        for (let i = 0; i < tasks.length; i++) {
            const parts = [
                tasks[i]?.destinationArea,
                tasks[i]?.destinationCity,
                tasks[i]?.destinationState
            ].filter(Boolean);
            
            const dest = parts.join(", ");
            if (dest) {
                if (str !== "") str += " -> ";
                str += dest;
            }
        }
        return str;
    };

    const exportTADAReport = async () => {
        setIsExporting(true);
        try {
            const startTime = new Date(fromDate).setHours(0, 0, 0, 0);
            const endTime = new Date(toDate).setHours(23, 59, 59, 999);
            
            const [resp, periodicResp] = await Promise.all([
                axios.get(`${DEV_SERVER}/trip/v2/getAllTrips?startTime=${startTime}&endTime=${endTime}`, {
                    headers: {
                        Authorization: `Bearer ${userSignal.value?.token}`,
                    },
                }),
                axios.get(`${DEV_SERVER}/expense/v2/periodicExpenses?startTime=${startTime}&endTime=${endTime}`, {
                    headers: {
                        Authorization: `Bearer ${userSignal.value?.token}`,
                    },
                })
            ]);
            
            if (resp.data && resp.data.status) {
                let fetchedTrips = resp.data.data || [];
                let fetchedPeriodic = (periodicResp.data && periodicResp.data.status) ? (periodicResp.data.data || []) : [];
                
                // Filter by state if configured
                let stateName = window.localStorage.getItem("state");
                if (stateName) {
                    fetchedTrips = fetchedTrips.filter((item) => {
                        if (allUsersSignal.value[item.userId]) {
                            return allUsersSignal.value[item.userId]?.state === stateName;
                        }
                        return false;
                    });
                    fetchedPeriodic = fetchedPeriodic.filter((item) => {
                        const uId = item.userId?.[0]?.id || item.userId?.[0]?._id || (typeof item.userId === 'string' ? item.userId : null);
                        if (allUsersSignal.value[uId]) {
                            return allUsersSignal.value[uId]?.state === stateName;
                        }
                        return false;
                    });
                }
                
                if (fetchedTrips.length === 0 && fetchedPeriodic.length === 0) {
                    toast.info("No records found for the selected filter to export.");
                    setIsExporting(false);
                    return;
                }
                
                const headers = [
                    'Staff Name',   'Date',
                    'Start Detail', 'End Detail',
                    'Start KM',     'End KM',
                    'Distance',     'VehicleType',
                    'D.A. Type',    'D.A. Amt',
                    'TA Amt',       'Fixed Exp',
                    'Expense',      'TOTAL',
                    'Visit Count'
                ];
                
                const sheetData = [headers];
                
                // Track trip keys to map periodic expenses
                const tripKeys = new Set();
                fetchedTrips.forEach(t => {
                    const dateStr = moment(t.date).format("DD/MM/YYYY");
                    tripKeys.add(`${t.userId}_${dateStr}`);
                });
                
                // Group fixed expenses by userId and dateStr
                const fixedExpMap = {};
                const unmatchedGrouped = {};
                
                fetchedPeriodic.forEach(pe => {
                    const uId = pe.userId?.[0]?.id || pe.userId?.[0]?._id || (typeof pe.userId === 'string' ? pe.userId : null);
                    if (!uId) return;
                    const dateStr = moment(pe.createdAt).format("DD/MM/YYYY");
                    const key = `${uId}_${dateStr}`;
                    
                    fixedExpMap[key] = (fixedExpMap[key] || 0) + (parseFloat(pe.amount) || 0);
                    
                    if (!tripKeys.has(key)) {
                        if (!unmatchedGrouped[key]) {
                            unmatchedGrouped[key] = {
                                userId: uId,
                                dateStr,
                                amount: 0,
                                titles: []
                            };
                        }
                        unmatchedGrouped[key].amount += parseFloat(pe.amount) || 0;
                        if (pe.title && !unmatchedGrouped[key].titles.includes(pe.title)) {
                            unmatchedGrouped[key].titles.push(pe.title);
                        }
                    }
                });
                
                let sumDistance = 0;
                let sumDA = 0;
                let sumTA = 0;
                let sumFixed = 0;
                let sumExpense = 0;
                let sumTotal = 0;
                let sumVisits = 0;
                
                const dataRows = [];
                
                fetchedTrips.forEach((t) => {
                    const staffName = allUsersSignal.value[t.userId]?.name || "Unknown";
                    const dateStr = moment(t.date).format("DD/MM/YYYY");
                    
                    const startDetail = t.route || buildRouteFromTasks(t) || "Local Working";
                    const endDetail = t.isCompleted ? (t.isNotEnded ? "Not Ended" : "Todays Work Completed") : "On Going";
                    
                    const startKm = t.startKM !== undefined && t.startKM !== null ? parseFloat(t.startKM) : 0;
                    const endKm = t.endKM !== undefined && t.endKM !== null ? parseFloat(t.endKM) : 0;
                    const distance = parseFloat(t.totalDistance / 1000) || 0;
                    
                    const vehicleType = t.modeOfTransport || "";
                    const daType = t.dailyAllowance || "";
                    const daAmt = parseFloat(t.dailyAllowanceExpense) || 0;
                    
                    // TA calculation
                    const rate = getRatePerKm(t.userId, vehicleType);
                    const taAmt = distance * rate;
                    
                    // Fixed Expense calculation
                    const key = `${t.userId}_${dateStr}`;
                    const fixedExp = fixedExpMap[key] || 0;
                    
                    // Expense: custom trip expenses
                    const exp = Math.max(0, (parseFloat(t.totalExpense) || 0) - daAmt - taAmt);
                    
                    // TOTAL
                    const total = daAmt + taAmt + exp + fixedExp;
                    const visitCount = parseInt(t.tasksCompleted) || 0;
                    
                    sumDistance += distance;
                    sumDA += daAmt;
                    sumTA += taAmt;
                    sumFixed += fixedExp;
                    sumExpense += exp;
                    sumTotal += total;
                    sumVisits += visitCount;
                    
                    dataRows.push({
                        dateObj: moment(t.date),
                        row: [
                            staffName,
                            dateStr,
                            startDetail,
                            endDetail,
                            t.startKM !== undefined && t.startKM !== null ? parseFloat(t.startKM) : "",
                            t.endKM !== undefined && t.endKM !== null ? parseFloat(t.endKM) : "",
                            parseFloat(distance.toFixed(2)),
                            vehicleType,
                            daType,
                            parseFloat(daAmt.toFixed(2)),
                            parseFloat(taAmt.toFixed(2)),
                            parseFloat(fixedExp.toFixed(2)),
                            parseFloat(exp.toFixed(2)),
                            parseFloat(total.toFixed(2)),
                            visitCount
                        ]
                    });
                });
                
                // Add unmatched fixed expenses
                Object.values(unmatchedGrouped).forEach((item) => {
                    const staffName = allUsersSignal.value[item.userId]?.name || "Unknown";
                    
                    sumFixed += item.amount;
                    sumTotal += item.amount;
                    
                    dataRows.push({
                        dateObj: moment(item.dateStr, "DD/MM/YYYY"),
                        row: [
                            staffName,
                            item.dateStr,
                            `Fixed Expense: ${item.titles.join(", ")}`,
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            parseFloat(item.amount.toFixed(2)),
                            "",
                            parseFloat(item.amount.toFixed(2)),
                            ""
                        ]
                    });
                });
                
                // Sort all rows by date ascending
                dataRows.sort((a, b) => a.dateObj.valueOf() - b.dateObj.valueOf());
                dataRows.forEach(item => sheetData.push(item.row));
                
                // Add totals row at the bottom
                const totalRow = new Array(15).fill("");
                totalRow[0] = 'TOTAL';
                totalRow[6] = parseFloat(sumDistance.toFixed(2));
                totalRow[9] = parseFloat(sumDA.toFixed(2));
                totalRow[10] = parseFloat(sumTA.toFixed(2));
                totalRow[11] = parseFloat(sumFixed.toFixed(2));
                totalRow[12] = parseFloat(sumExpense.toFixed(2));
                totalRow[13] = parseFloat(sumTotal.toFixed(2));
                totalRow[14] = Math.round(sumVisits);
                sheetData.push(totalRow);
                
                const ws = XLSX.utils.aoa_to_sheet(sheetData);
                ws['!autofilter'] = { ref: `A1:O${sheetData.length - 1}` };
                
                // Convert individual row totals to formulas so that editing cells dynamically updates the row total
                for (let i = 1; i <= sheetData.length - 2; i++) {
                    const rowIdx = i + 1;
                    const cellRef = `N${rowIdx}`;
                    const cachedVal = ws[cellRef] ? ws[cellRef].v : 0;
                    ws[cellRef] = {
                        t: 'n',
                        f: `SUM(J${rowIdx}:M${rowIdx})`,
                        v: cachedVal
                    };
                }
                
                // Set SUBTOTAL formulas for total row to support dynamic filtering in Excel
                const totalRowExcelIdx = sheetData.length;
                const lastDataRowExcelIdx = totalRowExcelIdx - 1;
                
                ws[`G${totalRowExcelIdx}`] = { t: 'n', f: `SUBTOTAL(9,G2:G${lastDataRowExcelIdx})`, v: parseFloat(sumDistance.toFixed(2)) };
                ws[`J${totalRowExcelIdx}`] = { t: 'n', f: `SUBTOTAL(9,J2:J${lastDataRowExcelIdx})`, v: parseFloat(sumDA.toFixed(2)) };
                ws[`K${totalRowExcelIdx}`] = { t: 'n', f: `SUBTOTAL(9,K2:K${lastDataRowExcelIdx})`, v: parseFloat(sumTA.toFixed(2)) };
                ws[`L${totalRowExcelIdx}`] = { t: 'n', f: `SUBTOTAL(9,L2:L${lastDataRowExcelIdx})`, v: parseFloat(sumFixed.toFixed(2)) };
                ws[`M${totalRowExcelIdx}`] = { t: 'n', f: `SUBTOTAL(9,M2:M${lastDataRowExcelIdx})`, v: parseFloat(sumExpense.toFixed(2)) };
                ws[`N${totalRowExcelIdx}`] = { t: 'n', f: `SUBTOTAL(9,N2:N${lastDataRowExcelIdx})`, v: parseFloat(sumTotal.toFixed(2)) };
                ws[`O${totalRowExcelIdx}`] = { t: 'n', f: `SUBTOTAL(9,O2:O${lastDataRowExcelIdx})`, v: Math.round(sumVisits) };
                
                // Style header row & normal rows
                for (let r = 0; r < sheetData.length; r++) {
                    const isHeader = r === 0;
                    const isTotal = r === sheetData.length - 1;
                    for (let c = 0; c < headers.length; c++) {
                        const cellRef = XLSX.utils.encode_cell({ r, c });
                        if (!ws[cellRef]) continue;
                        
                        ws[cellRef].s = {
                            font: {
                                name: 'Calibri',
                                sz: 10,
                                bold: isHeader || isTotal
                            },
                            alignment: {
                                vertical: 'center',
                                horizontal: c === 0 || c === 2 || c === 3 || c === 7 || c === 8 ? 'left' : 'center'
                            },
                            border: {
                                top: { style: 'thin', color: { rgb: 'D3D3D3' } },
                                bottom: { style: 'thin', color: { rgb: 'D3D3D3' } },
                                left: { style: 'thin', color: { rgb: 'D3D3D3' } },
                                right: { style: 'thin', color: { rgb: 'D3D3D3' } }
                            }
                        };
                        
                        if (isHeader) {
                            ws[cellRef].s.fill = {
                                fgColor: { rgb: 'EAEAEA' }
                            };
                        }
                    }
                }
                
                // Set column widths
                ws['!cols'] = [
                    { width: 25 }, // Staff Name
                    { width: 12 }, // Date
                    { width: 30 }, // Start Detail
                    { width: 30 }, // End Detail
                    { width: 12 }, // Start KM
                    { width: 12 }, // End KM
                    { width: 12 }, // Distance
                    { width: 18 }, // VehicleType
                    { width: 18 }, // D.A. Type
                    { width: 12 }, // D.A. Amt
                    { width: 12 }, // TA Amt
                    { width: 12 }, // Fixed Exp
                    { width: 12 }, // Expense
                    { width: 15 }, // TOTAL
                    { width: 12 }  // Visit Count
                ];
                
                // Set row heights
                ws['!rows'] = sheetData.map((_, idx) => ({ hpx: idx === 0 ? 25 : 20 }));
                
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'TA DA Report');
                XLSX.writeFile(wb, `TA_DA_REPORT_${fromDate}_to_${toDate}.xlsx`);
                toast.success("TA/DA Report exported successfully!");
            } else {
                toast.error(resp.data?.message || "Failed to generate report.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error generating or exporting TA/DA report");
        } finally {
            setIsExporting(false);
        }
    };

    const handleDisplayFields = () => {
        setExpenseToDisplay(expenses.filter((item) => {

            if (minAmount && item.amount < minAmount) return false;
            if (maxAmount && item.amount > maxAmount) return false;
            if ((statusFilter && statusFilter !== "") && item.status !== statusFilter) return false;
            if (search === "") return true;
            if (item.title.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.description.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.amount.toString().includes(search.toLowerCase())) {
                return true;
            } else if (item.userId?.length > 0 && item.userId[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.status.toLowerCase().startsWith(search.toLowerCase())) {
                return true;
            } else if (item.reviewedBy?.length > 0 && item.reviewedBy[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.reason.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (moment(item.createdAt).format("DD/MM/YY hh:mm").includes(search.toLowerCase())) {
                return true;
            }
            return false;
        }))
    }

    const refetchExpenses = () => {
        getExpenses.refetch({ cancelRefetch: true });
    }

    const handleFilters = async () => {
        const tempSearchParam = new URLSearchParams({ fromDate: fromDate, toDate, minAmount, maxAmount, statusFilter });
        setSearchParams(tempSearchParam);
        await getExpenses.refetch({ cancelRefetch: true });
        handleDisplayFields();
    }

    useEffect(() => {
        handleDisplayFields();
    }, [search, expenses])

    const getExpenses = useQuery("expenses", async () => {
        let resp = await axios.get(`${DEV_SERVER}/expense/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                let stateName = window.localStorage.getItem("state");
                let temp = data.data

                if(stateName){
                    temp = temp.filter((item) => {
                        if(item?.userId?.length > 0 && allUsersSignal.value[item?.userId[0]?.id]?.state === stateName){
                            return true;
                        }else{
                            return false;
                        }
                    });
                }

                setExpenses(temp);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const updateExpenseStatusMutation = useMutation((data) => axios.post(`${DEV_SERVER}/expense/v2/updateStatus/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                refetchExpenses();
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    let updateExpenseStatus = (id, status, reason) => {
        updateExpenseStatusMutation.mutate({ id, body: { status, reason } })
    }

    useEffect(() => {
        refetchExpenses();
    }, [])

    const handleRowClick = (row) => {
        setSelectedExpense(row);
        setShowExpenseViewModal(true);
    }

    const columns = [
        {
            name: "Title",
            color: true,
            center: true,
            selector: "title",
        },
        {
            name: "Description",
            color: true,
            center: true,
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.description}</Tooltip>}><span onClick={() => handleRowClick(row)}>{row?.description}</span></OverlayTrigger>

            },
        },
        {
            name: "Amount",
            color: true,
            center: true,
            selector: "amount",
            cell: (row) => `₹ ${parseFloat(row?.amount).toFixed(2)}`,
            sortable: true,
        },
        {
            name: "Date",
            color: true,
            center: true,
            selector: "createdAt",
            cell: (row) => moment(row?.createdAt).format("DD/MM/YY hh:mm A"),
            sortable: true,
        },
        {
            name: "Media",
            color: true,
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.media?.length > 0 && row?.media?.map((m) =>
                    <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>

                )}
            </div>
        },
        {
            name: "User",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.userId?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.userId[0]?.name}</Tooltip>}>
                        <span onClick={() => handleRowClick(row)} style={{ display: "flex", columnGap: "0.5rem", alignItems: "center" }}>
                            <img style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={row?.userId[0].profileURL !== "" ? row?.userId[0].profileURL : avatar1} />
                            {row?.userId[0].name}
                        </span>
                    </OverlayTrigger>
                } else {
                    return "NA"
                }
            }
        },
        {
            name: "Status",
            color: true,
            center: true,
            selector: (row) => <span style={{ color: row?.status === "pending" ? "orange" : (row?.status === "approved" ? "green" : "red") }}>{row?.status}</span>
        },
        {
            name: "Reviewed By",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.reviewedBy?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reviewedBy[0]?.name}</Tooltip>}>
                        <span onClick={() => handleRowClick(row)}>{row?.reviewedBy[0].name}</span>
                    </OverlayTrigger>
                }
                return "NA"
            }
        },
        {
            name: "Reason",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.status === "pending") {
                    return <textarea style={{ width: "100%" }} value={text[row?.id] || ""} onChange={(e) => setText({ ...text, [row?.id]: e.target.value })} ></textarea>
                } else {
                    return row?.reason === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reason}</Tooltip>}><span>{row?.reason}</span></OverlayTrigger>
                }
            }
        },
        {
            name: "Action",
            color: true,
            center: true,
            selector: (row) => <span style={{ display: "flex", alignItems: "center", justifyContent: "center", columnGap: "0.8rem", opacity: row?.status === "pending" ? 1 : 0.5 }}>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Reject</Tooltip>}><i onClick={(e) => updateExpenseStatus(row?.id, "rejected", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "red" }} class="fas fa-times"></i></OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Approve</Tooltip>}><i onClick={(e) => updateExpenseStatus(row?.id, "approved", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "green" }} class="fas fa-check"></i></OverlayTrigger>
            </span>
        },
        {
            name: "Location",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.location?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.location[0]},${row?.location[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>
                }
                return "NA"
            }
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Expense List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header><b>Filters</b></Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" value={fromDate} onChange={(e) => {
                                                        setFromDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" value={toDate} onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="minAmount">Min Amount</label>
                                                    <input type="number" id="minAmount" className="form-control vanila-datepicker" names="start" placeholder="Min Amount" value={minAmount} onChange={(e) => {
                                                        setMinAmount(e.target.value)

                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxAmount">Max Amount</label>
                                                    <input type="number" id="maxAmount" className="form-control vanila-datepicker" names="start" placeholder="Max Amount" value={maxAmount} onChange={(e) => {
                                                        setMaxAmount(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="statusFilter">Status</label>
                                                    <select value={statusFilter} onChange={(e) => {
                                                        setStatusFilter(e.target.value);
                                                    }} className="form-control">
                                                        <option value="">All</option>
                                                        <option value="pending">Pending</option>
                                                        <option value="approved">Approved</option>
                                                        <option value="rejected">Rejected</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setFromDate(moment(sevenDaysAgo).format("YYYY-MM-DD"));
                                                    setToDate(moment(today).format("YYYY-MM-DD"));
                                                    setMinAmount(0);
                                                    setMaxAmount(0);
                                                    setStatusFilter("");
                                                    const tempSearchParam = new URLSearchParams({ fromDate: moment(sevenDaysAgo).format("YYYY-MM-DD"), toDate: moment(today).format("YYYY-MM-DD"), minAmount: 0, maxAmount: 0, statusFilter: "" });
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                <div className="mt-2 d-flex justify-content-between align-items-center" style={{ marginBottom: "1rem" }}>
                                    <div>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => {
                                            setSearch(e.target.value)
                                        }} />
                                    </div>
                                    <button 
                                        className="btn btn-success d-flex align-items-center" 
                                        onClick={exportTADAReport} 
                                        disabled={isExporting}
                                        style={{ height: "fit-content" }}
                                    >
                                        {isExporting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Exporting...
                                            </>
                                        ) : "Export Report"}
                                    </button>
                                </div>
                                {(!getExpenses.isLoading && !getExpenses?.isFetching) && <DataTable
                                    customStyles={
                                        {
                                            rows: {
                                                style: {
                                                    cursor: "pointer",
                                                    backgroundColor: "unset"
                                                }
                                            }
                                        }
                                    }
                                    onRowClicked={(row) => {
                                        handleRowClick(row);
                                    }} columns={columns} data={expenseToDisplay} pagination={true} />}
                                {(getExpenses.isLoading || getExpenses?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {showExpenseViewModal && <ExpenseViewModal updateExpenseStatus={updateExpenseStatus} expense={selectedExpense} show={showExpenseViewModal} close={() => setShowExpenseViewModal(false)} />}
        </>
    )
}